import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/nhan-su/bao-hiem'

// Lọc danh sách đóng bảo hiểm
export function locDongBaoHiem(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach-dong-bao-hiem`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lọc danh sách chế độ bảo hiểm
export function locCheDoBaoHiem(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach-che-do-bao-hiem`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy bảo hiểm nhân viên
export function layBaoHiemNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/bao-hiem`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy đóng bảo hiểm nhân viên
export function layDongBaoHiemNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/dong-bao-hiem`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chế độ bảo hiểm nhân viên
export function layCheDoBaoHiemNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/che-do-bao-hiem`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo bảo hiểm nhân viên
export function taoBaoHiemNhanVien(userId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-bao-hiem-nhan-vien?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật bảo hiểm nhân viên
export function capNhatBaoHiemNhanVien(insuranceId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${insuranceId}/cap-nhat-bao-hiem-nhan-vien`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa bảo hiểm nhân viên
export function xoaBaoHiemNhanVien(insuranceId: number) {
  try {
    return axiosApi.delete(`${BASE}/${insuranceId}/xoa-bao-hiem-nhan-vien`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo đóng bảo hiểm
export function taoDongBaoHiem(userId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-dong-bao-hiem?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật đóng bảo hiểm
export function capNhatDongBaoHiem(paymentId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/dong-bao-hiem/${paymentId}/cap-nhat-dong-bao-hiem`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa đóng bảo hiểm
export function xoaDongBaoHiem(paymentId: number) {
  try {
    return axiosApi.delete(`${BASE}/dong-bao-hiem/${paymentId}/xoa-dong-bao-hiem`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo chế độ bảo hiểm
export function taoCheDoBaoHiem(userId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-che-do-bao-hiem?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật chế độ bảo hiểm
export function capNhatCheDoBaoHiem(benefitId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/che-do-bao-hiem/${benefitId}/cap-nhat-che-do-bao-hiem`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa chế độ bảo hiểm
export function xoaCheDoBaoHiem(benefitId: number) {
  try {
    return axiosApi.delete(`${BASE}/che-do-bao-hiem/${benefitId}/xoa-che-do-bao-hiem`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
